export const USER_LOGIN = 'userLogin';
export const USER_LOGOUT = 'userLogout';
export const SET_AUTHENTICATED_USER = 'setAuthUser';
